// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bZDG","importantInfo":"styles_importantInfo__1OjzC"};